import { render, staticRenderFns } from "./OfficeDelete.vue?vue&type=template&id=69194b44&scoped=true&"
import script from "./OfficeDelete.vue?vue&type=script&lang=js&"
export * from "./OfficeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69194b44",
  null
  
)

export default component.exports